import { useAxiosInstance } from '@gov-nx/api/axios';
import type { SecurityAutorizaceOdpovedDTO } from '@gov-nx/api/generated/security.types';
import {
	dokonciAutorizaci,
	vypisPolozkaAutorizaceId,
} from '@gov-nx/api/queries/authQuery';
import { form602SubmissionDeleteQuery } from '@gov-nx/api/queries/formsQuery';
import type { Optional } from '@gov-nx/core/types/helpers.types';
import { is, isNonEmptyString } from '@gov-nx/core/types/helpers.types';
import { useAutorizaceStore } from '@gov-nx/store/autorizace/store';

export const useAuthorizationCleanup = () => {
	const { axiosInstance } = useAxiosInstance();
	const authorizationId = useAutorizaceStore('authorizationId');

	const finalizeAuthorization = async (): Promise<
		SecurityAutorizaceOdpovedDTO['status']
	> => {
		if (!is(authorizationId)) {
			return undefined;
		}
		try {
			const { data } = await dokonciAutorizaci({
				axiosInstance,
				authorizationId,
			});
			return data.status;
		} catch {
			return undefined;
		}
	};

	const resolveSubmissionId = async (
		ukonId: Optional<string>
	): Promise<Optional<string>> => {
		if (!isNonEmptyString(ukonId)) {
			return undefined;
		}
		try {
			const { data } = await vypisPolozkaAutorizaceId({
				axiosInstance,
				ukonId,
			});
			return isNonEmptyString(data?.polozkaAutorizaceId)
				? data.polozkaAutorizaceId
				: undefined;
		} catch {
			return undefined;
		}
	};

	const deleteSubmission = async (formularPodaniId: Optional<string>) => {
		if (!isNonEmptyString(formularPodaniId)) {
			return;
		}
		try {
			await form602SubmissionDeleteQuery({ axiosInstance, formularPodaniId });
		} catch {
			return;
		}
	};

	return { finalizeAuthorization, resolveSubmissionId, deleteSubmission };
};
